import React from 'react';
import { Button, Flex, Heading, Icon } from '@televet/kibble-ui';
import { useHistory } from 'react-router-dom';
import { useSettingPageDetail } from '../hooks/useSettingPageDetail';
import { RouteBasePaths, SettingsRoutes } from 'routes';

const SettingsHeader = ({ relativePath, isMobile }: { relativePath: string; isMobile: boolean }): JSX.Element => {
  const { allSectionsOptions } = useSettingPageDetail();
  const pageDetail = allSectionsOptions.find((page) => page.relativePath === relativePath);
  const history = useHistory();

  return (
    <Flex
      align="center"
      flex="0 0 auto"
      h="64px"
      p={isMobile ? 3 : 5}
      bg={isMobile ? 'background.default' : 'transparent'}
      borderBottom="1px solid"
      borderColor="border.default"
    >
      {isMobile && relativePath !== SettingsRoutes.Index && (
        <Button
          size="xs"
          rightIcon={<Icon name="chevronLeft" size="md" />}
          variant="ghost"
          ml={-2}
          pr={1}
          pl={1}
          h="100%"
          onClick={(): void => history.replace(`${RouteBasePaths.Settings}`)}
        />
      )}
      <Heading size="md">{pageDetail?.label ?? 'Settings'}</Heading>
    </Flex>
  );
};

export default SettingsHeader;
